export const generateYearOptions = (startYear = 1960, endYear = new Date().getFullYear()): string[] => {
  const years: string[] = [];
  for (let year = endYear; year >= startYear; year--) {
    years.push(year.toString());
  }
  return years;
};
